/* eslint-disable */
const { KitModule, registerModule } = window;

import Swiper from "swiper";
import { A11y, Navigation, Pagination } from "swiper/modules";

class Carousel extends KitModule {
  constructor($element) {
    super($element);
    this.length = this.$element.dataset.length
    this.settings = this.$element.dataset.settings
      ? JSON.parse(this.$element.dataset.settings)
      : {};

    this.params = {
      modules: [A11y, Navigation, Pagination],
      slidesPerView: 1.3,
      spaceBetween: 24,
      loop: this.length > 4 ? true : false,
      slideActiveClass: "swiper-slide--active",
      breakpoints: {
        800: {
          slidesPerView: 2.09
        },
        1098: {
          slidesPerView: 3,
        },
        1440: {
          slidesPerView: 4,
        },
        1920: {
          slidesPerView: 4.2
        }
      },
      grabCursor: true,
      pagination: {
        clickable: true,
        el: ".pagination__list",
        renderBullet: function (index, className) {
          return `<button class="pagination__list-number ${className}"><span class="visually-hidden">${index + 1}</span></button>`;
        },
      },
      navigation: {
        nextEl: ".next",
        prevEl: ".previous",
      },
    };

    const swiperEl = `#${this.$element.id}`;
    const swiperOptions = { ...this.params, ...this.settings };
    const swiper = new Swiper(swiperEl, swiperOptions);
  }
}

registerModule("Carousel", Carousel);
